<template>
  <div class="pagination-goto">
    <div class="pagination-goto__label">
      {{ _getTr("go_to_page") }}
    </div>
    <MInput
      class="pagination-goto__input"
      :small="true"
      :value="currentPageStr"
      :emit-input-only-on-change="false"
      @input="changePage"
    />
  </div>
</template>

<script>

  import MInput from 'components/Inputs/Basic/MInput';

  export default {
    name: 'PaginationGoto',
    components: {MInput},
    props: {
      currentPage: {
        type: Number,
        required: true
      },
      firstPage: {
        type: Number,
        required: true
      },
      lastPage: {
        type: Number,
        required: true
      }
    },
    computed: {
      currentPageStr () {
        return String(this.currentPage);
      }
    },
    methods: {
      isValidNumber (strNumber) {
        const number = parseInt(strNumber);

        if (isNaN(number)) {
          return false;
        }
        if (number < 0) {
          return false;
        }

        return true;
      },
      processNumber (strNumber) {
        const number = parseInt(strNumber);

        if (number < this.firstPage) {
          return this.firstPage;
        }
        if (number > this.lastPage) {
          return this.lastPage;
        }

        return number;
      },
      changePage (number) {
        if (!this.isValidNumber(number)) {
          return;
        }

        this.$emit('input', this.processNumber(number));
      }
    }
  };
</script>

<style>
  .pagination-goto {
    text-align: center;

    display: flex;

    align-items: center;

    margin-right: auto;
  }

  .pagination-goto__input {
    width: 50px;

    & .input__field {
      margin-bottom: 0;
    }
  }

  .pagination-goto__label {
    margin-right: 8px;
  }

  @media (--small), (--extra-small) {
    .pagination-goto {
      margin-right: initial;
    }

    .pagination-goto__label {
      margin-right: 3px;
    }
  }

  @media (--extra-small) {
    .pagination-goto {
      margin-top: 10px;
    }

    .pagination-goto__label {
      margin-right: 8px;
    }
  }
</style>
